// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__10eCT","modalForm":"UpgradeEpcsModal_modalForm__KlqUE","modalFooter":"UpgradeEpcsModal_modalFooter__3OzJk"};